import { getStoreScopedPath } from "@redotech/redo-merchant-app-common/routing/store-scope";

export function getFaireCallbackPath(url: URL): string | undefined {
  if (url.pathname !== "/faire/callback") {
    return undefined;
  }

  const teamId = url.searchParams.get("state");
  if (!teamId || !/^[0-9a-f]{24}$/.test(teamId)) {
    return undefined;
  }

  return getStoreScopedPath(teamId, url.pathname + url.search + url.hash);
}
